import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_WAGES_AND_SALARY } from './get-all-wages-and-salary.hook';

export const UPDATE_WAGES_AND_SALARY = gql`
  mutation updateWagesAndSalary($payload: UpdateWagesAndSalaryInput!) {
    updateWagesAndSalary(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateWagesAndSalary = ({ onSuccess }: { onSuccess?: () => void }) => {
  const { t } = useTranslation('employee');
  const [updateWagesAndSalary, { loading }] = useMutation(UPDATE_WAGES_AND_SALARY, {
    onCompleted: data => {
      if (data?.updateWagesAndSalary) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('wagesAndSalary.notifications.updated'),
        });
        if (onSuccess) {
          onSuccess();
        }
      }
    },
    refetchQueries: [GET_WAGES_AND_SALARY],
  });

  return { updateWagesAndSalary, loading };
};
